import isMobile from 'piramis-js-utils/lib/isMobile'
import Vue from 'vue'
import { Component, Emit, Prop, VModel, Watch } from 'vue-property-decorator'

import { VueComponent } from '../../../../shared/types/VueComponent'
import ButtonsManager
  from './ButtonsManager'
import Button, { ButtonStruct } from './buttons'

@Component
export default class ButtonsBuilderMixin extends Vue {
  @VModel() isOpen!: boolean

  @Prop() manager!: ButtonsManager

  @Prop() buttonsHelpView!: VueComponent | string

  @Watch('isOpen')
  indexWatcher(val: boolean): void {
    if (!this.manager.soloButton) {
      if (!val) {
        this.currentButton = null
      }
    } else {
      this.currentButton = Object.values(this.manager.buttons)[0]
    }
  }

  currentButton: Button | null = null

  helpMessageIsOpen = false

  closeModalHandler(): void {
    this.manager.refreshData()
    this.currentButton = null
  }

  checkIsMobile(): boolean {
    if (isMobile()) {
      return !this.helpMessageIsOpen
    }
    return true
  }

  @Emit()
  addButton(): ButtonStruct | void {
    if (this.currentButton) {
      return this.currentButton.create()
    }
  }

  created(): void {
    if (this.manager.soloButton) {
      this.currentButton = Object.values(this.manager.buttons)[0]
    }
  }
}
